import { RouteConstants } from '@/features/router/RouteConstants';
import { PageLayout, PageListHeader } from '@/global/components';
import { BreadcrumbItem } from '@/lib/Breadcrumbs';
import { FC } from 'react';
import { AddAudienceButton } from './AddAudienceButton';
import { AudiencesTable, AudienceTableSearch } from './AudiencesTable';

const breadcrumbs: BreadcrumbItem[] = [
  {
    label: 'audiences:title',
    path: RouteConstants.audiences,
  },
];

export const AudiencesV2: FC = () => {
  return (
    <PageLayout>
      <PageListHeader breadcrumbs={breadcrumbs} title='audiences.empty_set.title' subtitle='audiences.empty_set.subtitle'>
        <AddAudienceButton />
      </PageListHeader>
      <div className='flex flex-col gap-4'>
        <AudienceTableSearch />
        <AudiencesTable />
      </div>
    </PageLayout>
  );
};
